import React, { Fragment, useEffect, useState } from "react";
import Breadcrumb from "../common/breadcrumb";
import "react-toastify/dist/ReactToastify.css";
import {
	Button,
	Card,
	CardBody,
	Col,
	Container,
	Form,
	FormGroup,
	Input,
	Label,
	Modal,
	ModalBody,
	ModalFooter,
	ModalHeader,
	Row,
} from "reactstrap";
import axiosInstance from "../axios";
import DatatableCategory from "../common/datatableCategory";
import { toast } from "react-toastify";
import { ProgressBar } from "primereact/progressbar";

const Category = () => {
	const [render, setRender] = useState(false);
	const [open, setOpen] = useState(false);
	const [data, setData] = useState([]);
	const [formData, updateFormData] = useState(null);
	const [selectedSeason, setSelectedSeason] = useState(null);
	const seasons = [
		{ name: "شتوى", code: "winter" },
		{ name: "صيفى", code: "summer" },
	];
	function HandleRender() {
		setRender(!render);
	}
	const onOpenModal = () => {
		setOpen(true);
	};

	const onCloseModal = () => {
		setOpen(false);
	};

	useEffect(() => {
		axiosInstance.get(`/products/category`).then((res) => {
			setData(res.data);
		});
	}, [render]);

	const [image, setImage] = useState(null);
	const [progressValue, setProgressValue] = useState(0);
	const config = {
		headers: { "Content-Type": "multipart/form-data" },
		onUploadProgress: function (progressEvent) {
			var percentCompleted = Math.round(
				(progressEvent.loaded * 100) / progressEvent.total
			);
			setProgressValue(percentCompleted);
		},
	};
	const handleSubmit = (e) => {
		if (formData !== null || image !== null) {
			const formData1 = new FormData();
			formData1.append("name_ar", formData?.name_ar);
			formData1.append("name_en", formData?.name_en);
			if (formData?.description_ar) {
				formData1.append("description_ar", formData?.description_ar);
			}
			if (formData?.description_en) {
				formData1.append("description_en", formData?.description_en);
			}
			if (formData?.season) {
				formData1.append("season", formData?.season);
			}
			formData1.append("url", image);
			e.preventDefault();
			axiosInstance
				.post(`/products/category`, formData1, config)
				.then((res) => {
					setProgressValue(0);
					updateFormData(null);
					setRender(!render);
					onCloseModal("VaryingMdo");

					toast.success("تم الانشاء بنجاح");
				})
				.catch((err) => {
					setProgressValue(0);
					if (err.response.status === 400) {
						toast.warning(`تاكد من البيانات المدخلة`);
					} else {
						toast.error(`${err.response.status} تاكد من البيانات المدخلة`);
					}
				});
		} else {
			toast.warning("تاكد من البيانات المدخلة");
		}
	};

	const handleChange = (e) => {
		updateFormData({
			...formData,
			// Trimming any whitespace
			[e.target.name]: e.target.value,
		});
	};

	const handleChangeImage = (e) => {
		setImage(e.target.files[0]);
		// Trimming any whitespace
	};

	const handleChangeSeason = (value) => {
		updateFormData({
			...formData,
			season: value,
		});
	};

	return (
		<Fragment>
			<Breadcrumb title="الاقسام" />
			{/* <!-- Container-fluid starts--> */}
			<Container fluid={true}>
				<Row>
					<Col sm="12">
						<Card>
							{/* <CardHeader>
								<h5>الاقسام</h5>
							</CardHeader> */}
							<CardBody>
								<div className="btn-popup pull-right">
									<Button
										type="button"
										color="primary"
										onClick={onOpenModal}
										data-toggle="modal"
										data-original-title="test"
										data-target="#exampleModal"
									>
										اضافة قسم جديد
									</Button>
									<Modal
										isOpen={open}
										toggle={onCloseModal}
										style={{ overlay: { opacity: 0.1 } }}
									>
										<ModalHeader toggle={onCloseModal}>
											<h5
												className="modal-title f-w-600"
												id="exampleModalLabel2"
											>
												اضافة قسم جديد
											</h5>
										</ModalHeader>
										<ModalBody>
											<Form>
												<FormGroup>
													<Label
														htmlFor="recipient-name"
														className="col-form-label"
													>
														الاسم عربى :
													</Label>
													<Input
														type="text"
														name="name_ar"
														className="form-control"
														onChange={handleChange}
													/>
												</FormGroup>
												<FormGroup>
													<Label
														htmlFor="recipient-name"
														className="col-form-label"
													>
														الاسم انجليزي :
													</Label>
													<Input
														type="text"
														name="name_en"
														className="form-control"
														onChange={handleChange}
													/>
												</FormGroup>
												<FormGroup>
													<Label
														htmlFor="recipient-name"
														className="col-form-label"
													>
														الوصف عربى :
													</Label>
													<Input
														type="text"
														name="description_ar"
														className="form-control"
														onChange={handleChange}
													/>
												</FormGroup>
							<FormGroup>
								<Label
									htmlFor="recipient-name"
									className="col-form-label"
								>
									الوصف انجليزي :
								</Label>
								<Input
									type="text"
									name="description_en"
									className="form-control"
									onChange={handleChange}
								/>
							</FormGroup>
							<FormGroup>
								<Label
									htmlFor="season-select"
									className="col-form-label"
									style={{ marginLeft: 15 }}
								>
									الموسم
								</Label>
								<Input
									id="season-select"
									name="select"
									type="select"
									onChange={(e) => {
										setSelectedSeason(e.target.value);
										handleChangeSeason(e.target.value);
									}}
								>
									<option selected={true} disabled="disabled">
										برجاء اختيار موسم
									</option>
									{seasons.map((season) => (
										<option key={season.code} value={season.code}>
											{season.name}
										</option>
									))}
								</Input>
							</FormGroup>
							<FormGroup>
								<Label
									htmlFor="message-text"
									className="col-form-label"
								>
									صورة القسم :<span>مقاس الصورة 500 * 500</span>
								</Label>
								<Input
									name="url"
									className="form-control"
									id="validationCustom02"
									type="file"
									onChange={handleChangeImage}
								/>
							</FormGroup>
												<div className="card">
													<ProgressBar
														color="secondary"
														value={progressValue}
													></ProgressBar>
												</div>
											</Form>
										</ModalBody>
										<ModalFooter className="d-flex justify-content-between">
											<Button
												type="button"
												color="secondary"
												onClick={(e) => {
													handleSubmit(e);
												}}
											>
												حفظ
											</Button>
											<Button
												type="button"
												color="primary"
												onClick={() => onCloseModal("VaryingMdo")}
											>
												اغلاق
											</Button>
										</ModalFooter>
									</Modal>
								</div>
								<div className="clearfix"></div>
								<div id="basicScenario" className="product-physical">
									<DatatableCategory
										myData={data}
										multiSelectOption={false}
										pageSize={10}
										pagination={true}
										class="-striped -highlight"
										HandleRender={HandleRender}
									/>
								</div>
							</CardBody>
						</Card>
					</Col>
				</Row>
			</Container>
			{/* <!-- Container-fluid Ends--> */}
		</Fragment>
	);
};

export default Category;
